import React from 'react';
import { menuData, parseSizes } from '../mock';

const MenuItemRow = ({ item }) => {
  const sizes = parseSizes(item.price);

  return (
    <li className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-x-3 py-2.5 group">
      
      <div className="min-w-0 flex items-end gap-2">
        <span className="text-[15px] text-[#2a1a0f] leading-snug break-words">
          {item.name}
        </span>

        <span className="hidden sm:block flex-1 border-b border-dotted border-[#2a1a0f]/25 mb-1" />
      </div>

      {sizes ? (
        <span className="text-[12px] sm:text-[13px] text-[#b8532a] whitespace-nowrap text-right">
          <span className="text-[#7a5c40] mr-1">Sm</span>
          {sizes[0].price}
          <span className="mx-1 text-[#7a5c40]">·</span>
          <span className="text-[#7a5c40] mr-1">Lg</span>
          {sizes[1].price}
        </span>
      ) : (
        <span className="text-[15px] text-[#b8532a] whitespace-nowrap text-right">
          {item.price}
        </span>
      )}
    </li>
  );
};

const MenuCategory = ({ category }) => {
  return (
    <div className="pt-2">
      <div className="flex items-center gap-5 pb-6 border-t border-[#2a1a0f]/15 pt-6">
        <div className="w-16 h-16 rounded-2xl overflow-hidden flex-shrink-0">
          <img src={category.image} alt={category.title} className="w-full h-full object-cover" />
        </div>
        <h3 className="font-serif text-[28px] lg:text-[32px] text-[#2a1a0f] leading-tight">
          {category.title}
        </h3>
      </div>

      <ul className="flex flex-col">
        {category.items.map((item, idx) => {
          const chipList =
            item.flavors ||
            item.toppings ||
            item.styles ||
            (item.addons && item.addons.filter((a) => a !== 'No add-on'));
          const chipLabel = item.flavors
            ? 'Choose a flavour'
            : item.toppings
            ? 'Pizza choices'
            : item.styles
            ? 'Coffee styles'
            : item.addons
            ? 'Add-on options'
            : '';
          return (
            <React.Fragment key={idx}>
              <MenuItemRow item={item} />
              {chipList && (
                <li className="pb-3 pt-1 pl-1">
                  <div className="text-[11px] tracking-wider uppercase text-[#7a5c40] mb-1.5">
                    {chipLabel}
                  </div>
                  <div className="flex flex-wrap gap-1.5">
                    {chipList.map((f) => (
                      <span
                        key={f}
                        className="text-[11.5px] text-[#4a3524] bg-[#ecdcbf] border border-[#2a1a0f]/10 rounded-full px-2.5 py-0.5"
                      >
                        {f}
                      </span>
                    ))}
                  </div>
                </li>
              )}
            </React.Fragment>
          );
        })}
      </ul>

      {category.footnote && (
        <p className="mt-5 text-[13px] italic leading-relaxed text-[#7a5c40]">
          {category.footnote}
        </p>
      )}
    </div>
  );
};

const MenuSection = () => {
  const categories = Object.values(menuData);

  return (
    <section id="menu" className="bg-[#f4ead4] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 mb-16">
          <div>
            <div className="text-[12px] tracking-[0.16em] font-medium text-[#b8532a] uppercase mb-5">
              What we serve
            </div>
            <h2 className="font-serif text-[48px] sm:text-[60px] lg:text-[72px] leading-[1.02] text-[#2a1a0f] tracking-tight">
              The full Bliss menu.
            </h2>
          </div>
          <div className="lg:pt-6">
            <p className="text-[17px] leading-relaxed text-[#4a3524] max-w-lg">
              Breakfast, burgers, Indian favourites, pizza, coffee and more — made to order with
              vegetarian options throughout. Items with two prices come in Small &amp; Large.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-x-16 gap-y-4">
          {categories.map((cat, i) => (
            <MenuCategory key={i} category={cat} />
          ))}
        </div>

        <p className="mt-16 text-center text-[13px] italic text-[#7a5c40] max-w-3xl mx-auto">
          Menu and prices are based on the restaurant&apos;s published menu photos and may change.
          Please call to confirm current availability and pricing.
        </p>
      </div>
    </section>
  );
};

export default MenuSection;
